import DatePicker from './DatePicker'
import DatePickerRange from './DatePickerRange'
import NumericDatePickerRange from './NumericDatePickerRange'
import NumberDatePicker from './NumberDatePicker'
import DateTimepicker from './DateTimepicker'
import Calendar from './Calendar'
import RangeCalendar from './RangeCalendar'

DatePicker.DatePickerRange = DatePickerRange
DatePicker.NumericDatePickerRange = NumericDatePickerRange
DatePicker.NumberDatePicker = NumberDatePicker
DatePicker.DateTimepicker = DateTimepicker

export { Calendar, RangeCalendar, DatePickerRange, NumericDatePickerRange, NumberDatePicker }

export default DatePicker
